// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { menuCompactHeaderStyles } from "@steiner/App/Components/MenuCompactHeader/MenuCompactHeader";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

menuCompactHeaderStyles.menu = {
    cssOverrides: {
        menu: css`
            padding: 0;
        `,
        menuItem: css`
            box-shadow: 0 1px 0 0 ${color("common.ui3")};
            & .semibold {
                font-weight: ${fontConfig.weight.semiBold};
            }
        `,
    },
};
